import { FC, useEffect, useState } from 'react';
import cn from 'classnames';
import { FaArrowUp } from 'react-icons/fa';

import './RiskPopup.scss';

type RiskPopupProps = {
    style?: {
        [key: string]: any;
    };
    visible?: boolean;
    data: any;
    isGreenPopup?: boolean;
};

const RiskPopup: FC<RiskPopupProps> = ({ style, visible, data, isGreenPopup }) => {
    const countryCode = (data?.code || '').toLowerCase();
    const hasAlert = !!data?.countryAlert;

    const [percentageGreen, setPercentageGreen] = useState<any>('N/A');
    const [percentageGreening, setPercentageGreening] = useState<any>('N/A');
    const [percentageNotGreen, setPercentageNotGreen] = useState<any>('N/A');
    const [greenScore, setGreenScore] = useState<any>('N/A');
    const [greenRank, setGreenRank] = useState<any>('N/A');

    const [cyclicalScore, setCyclicalScore] = useState<any>('N/A');
    const [glriScore, setGLRIScore] = useState<any>('N/A');
    const [structuralScore, setStructuralScore] = useState<any>('N/A');
    const [cyclicalRank, setCyclicalRank] = useState<any>('N/A');
    const [glriRank, setGLRIRank] = useState<any>('N/A');
    const [structuralRank, setStructuralRank] = useState<any>('N/A');

    useEffect(() => {
        if (isGreenPopup) {
            setPercentageGreen(data && data.percentageGreen ? data.percentageGreen : 'N/A');
            setPercentageGreening(data && data.percentageGreening ? data.percentageGreening : 'N/A');
            setPercentageNotGreen(data && data.percentageNotGreen ? data.percentageNotGreen : 'N/A');
            setGreenScore(data && data.greenScore ? data.greenScore : 'N/A');
            setGreenRank(data && data.greenRank ? data.greenRank : 'N/A');
        }
        else {
            setCyclicalScore(data && data.cyclicalScore ? parseFloat(data.cyclicalScore) : 'N/A');
            setGLRIScore(data?.glriScore || 'N/A');
            setStructuralScore(data && data.cyclicalScore ? parseFloat(data?.structuralScore).toFixed(1) : 'N/A');
            setCyclicalRank(data?.cyclicalRank || 'N/A');
            setGLRIRank(data && data.cyclicalScore ? parseFloat(data?.glriRank) : 'N/A');
            setStructuralRank(data?.structuralRank || 'N/A');
        }
    }, [data, isGreenPopup]);

    return (
        <div
            className="risk-popup"
            style={{ ...style, visibility: visible ? 'visible' : 'hidden' }}
        >
            <div className="risk-popup__country-container">
                <div className="risk-popup__country-top">
                    {countryCode ? <div
                        className="risk-popup__flag"
                        style={{
                            backgroundImage: `url(https://flagcdn.com/${countryCode}.svg)`,
                        }}
                    ></div> : null}
                    <div className="risk-popup__country">{data?.country}</div>
                    <div
                        className={cn('risk-popup__bell', {
                            'risk-popup__bell_hidden': !hasAlert,
                        })}
                    >
                        <FaArrowUp />
                    </div>
                </div>
                <hr />
                <div className="risk-popup__country-information">
                    {!isGreenPopup ?
                        <>
                            <div className="risk-popup__column">
                                <div className="risk-popup__type">Cyclical</div>
                                <div className="risk-popup__value">{cyclicalScore}</div>
                            </div>
                            <div className="risk-popup__column">
                                <div className="risk-popup__type">GLRI score</div>
                                <div className="risk-popup__value">{glriScore}</div>
                            </div>
                            <div className="risk-popup__column">
                                <div className="risk-popup__type">Structural</div>
                                <div className="risk-popup__value">{structuralScore}</div>
                            </div>
                        </>
                        :
                        <>
                            <div className="risk-popup__column">
                                <div className="risk-popup__type">Green</div>
                                <div className="risk-popup__value">{percentageGreen}</div>
                            </div>
                            <div className="risk-popup__column">
                                <div className="risk-popup__type">Greening</div>
                                <div className="risk-popup__value">{percentageGreening}</div>
                            </div>
                            <div className="risk-popup__column">
                                <div className="risk-popup__type">Not Greening</div>
                                <div className="risk-popup__value">{percentageNotGreen}</div>
                            </div>
                        </>
                    }
                    
                </div>
            </div>
            <div className="risk-popup__ranks">
                {!isGreenPopup ?
                    <>
                        <div className="risk-popup__rank">
                            <div>Rank</div>
                            <div>{cyclicalRank}</div>
                        </div>
                        <div className="risk-popup__rank">
                            <div>Rank</div>
                            <div>{glriRank}</div>
                        </div>
                        <div className="risk-popup__rank">
                            <div>Rank</div>
                            <div>{structuralRank}</div>
                        </div>
                    </>
                    :
                    <>
                        <div className="risk-popup__rank">
                            <div>Score</div>
                            <div>{greenScore}</div>
                        </div>
                        <div className="risk-popup__rank">
                            <div>Rank</div>
                            <div>{greenRank}</div>
                        </div>
                    </>
                }
            </div>
            {!isGreenPopup &&
                <div className="risk-popup__ranks d-block py-2 px-2">
                    To find out more about the Global Labour Resilience Index, please <a href="https://whiteshield.com/insights/whiteshield-at-davos-the-global-labour-resilience-index-2024-a-call-for-climate-friendly-labour-markets/" target="_blank" rel="noreferrer">visit the Whiteshield Labour Markets & Resilience page.</a>
                </div>
            }
        </div>
    );
};

export default RiskPopup;
